export function clientFieldErrors({ email, password, firstName, lastName, mode }) {
  const errors = {};
  const trimmedEmail = (email || "").trim();
  if (!trimmedEmail) errors.email = "Enter your email address.";
  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail)) {
    errors.email = "Enter a valid email address.";
  }
  if (!password) errors.password = "Enter your password.";
  else if (mode === "signup" && password.length < 8) {
    errors.password = "Use at least 8 characters.";
  }
  if (mode === "signup") {
    if (!(firstName || "").trim()) errors.firstName = "Enter your first name.";
    if (!(lastName || "").trim()) errors.lastName = "Enter your last name.";
  }
  return errors;
}

export async function readApiError(response) {
  try {
    const body = await response.json();
    if (body.detail) return String(body.detail);
    if (body.error) return String(body.error);
    if (body.status === "Error" && body.detail) return String(body.detail);
  } catch {
    // not JSON
  }
  if (response.status === 429) return "Too many attempts. Wait a minute and try again.";
  if (response.status >= 500) return "Server error. Try again in a moment.";
  return `Something went wrong (${response.status}).`;
}
